import React, { ReactElement } from 'react'

import Footer from '../footer'
import { CountryContext } from '../../context'
import { Centre } from '../../../types/centre'
import { WestfieldPlusContainer } from './westfield-plus-container'
import { LeftColumnContainer } from './left-column-container'
import style from './index.scss'

export const UniversalFooter: React.FC<{ centre?: Centre }> = ({
  centre,
}): ReactElement => (
  <CountryContext.Consumer>
    {country => (
      <div className={style.footerContainer}>
        <Footer>
          {country === 'Australia' && <LeftColumnContainer centre={centre} />}
          <WestfieldPlusContainer country={country} />
        </Footer>
      </div>
    )}
  </CountryContext.Consumer>
)
